import { worktimeModel } from '../../../../../models/worktime.js'
import { View } from '../../../../../types.js'
import { WorktimeView } from '../../../../playtime/worktime/worktime.js'

interface ProfileProjectsTabProps {
    view: View
    userName: string
    userEmail: string | null
}

/**
 * The "Projektid" tab on another employee's profile. Reuses the playtime
 * Worktime view in its public-profile mode, scoped to the target's projects via
 * their work email (the same `isPublicProfile`/`userEmail` override the /me view
 * uses). Project filter prefs (search/sort/view mode) are shared app state —
 * intentional, they're view preferences, not per-person data.
 */
export const ProfileProjectsTab = ({ view, userName, userEmail }: ProfileProjectsTabProps) => (
    <WorktimeView
        {...worktimeModel.getProps(view, {
            isPublicProfile: true,
            userName,
            userEmail: userEmail ?? undefined,
        })}
    />
)
